import { request } from '@/plugins/axios'
// 首页第一屏
export async function orderCount(params) {
    return await request({
        url: '/api/u_is/orderCount',
        method: 'post',
        data:params
    })
}

// 大数据右屏
export async function distribution(params) {
    return await request({
        url: '/api/u_is/distribution',
        method: 'post',
        data:params
    })
}
// 大数据左屏
export async function bigData(params) {
    // console.log("加载左屏大数据"+params);
    return await request({
        url: '/api/u_is/bigData',
        method: 'post',
        data:params
    })
}
// 第三屏
export async function cateList(params) {
    return await request({
        url: '/api/u_is/cateList',
        method: 'post',
        data:params
    })
}
// 首页第四屏

export async function comment(params) {
    return await request({
        url: '/api/u_is/comment',
        method: 'post',
        data:params
    })
}
// 产品信息子页面

export async function getMore(params) {
    return await request({
        url: '/api/u_is/getMore',
        method: 'post',
        data:params
    })
}
export async function getProductList(params) {
    return await request({
        url: '/api/u_is/getProductList',
        method: 'post',
        data:params
    })
}
// 关于我们页面 了解全球验货
export async function srviceCount(params) {
    return await request({
        url: '/api/u_is/serviceCount',
        method: 'post',
        data:params
    })
}